import React, { useEffect, useRef, useState } from "react";
import "./optimizeActivitiesSection.scss";
import { ReactComponent as OptimizeCharts } from "./components/OptimizeCharts1.svg";
import { ReactComponent as OptimizePerson } from "./components/OptimizePerson.svg";
import { ReactComponent as OptimizeStar } from "./components/OptimizeStar.svg";

const OptimizeActivitiesSection = () => {
	const [isVisible, setIsVisible] = useState(false);
	const [visibleElements, setVisibleElements] = useState([false, false, false, false, false]);
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.2 }
		);

		if (sectionRef.current) {
			observer.observe(sectionRef.current);
		}

		return () => {
			if (observer && sectionRef.current) {
				observer.unobserve(sectionRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (isVisible) {
			visibleElements.forEach((_, index) => {
				setTimeout(() => {
					setVisibleElements((prev) =>
						prev.map((val, i) => (i === index ? true : val))
					);
				}, index * 600);
			});
		}
	}, [isVisible]);

	return (
		<div className="optimizeActivities" ref={sectionRef}>
			<div className="optimizeActivities__content">
				<div className="optimizeActivities__content_left">
					<h2
						className={`optimizeActivities__content_title fade-in ${
							visibleElements[0] ? "visible" : ""
						}`}
					>
						We create products to optimize your crypto activities
					</h2>
					<div
						className={`optimizeActivities__content_images fade-in ${
							visibleElements[1] ? "visible" : ""
						}`}
					>
						<OptimizePerson className="optimizeActivities__content_images_person" />
						<OptimizeStar className="optimizeActivities__content_images_big_star" />
						<OptimizeStar className="optimizeActivities__content_images_middle_star" />
						<OptimizeStar className="optimizeActivities__content_images_little_star" />
						<OptimizeCharts />
					</div>
				</div>
				<div className="optimizeActivities__content_right">
					{[
						"Our Team",
						"Tools",
						"5+ Successful Projects"
					].map((title, index) => (
						<div
							key={index}
							className={`optimizeActivities__content_text_item fade-in ${
								visibleElements[index + 2] ? "visible" : ""
							}`}
						>
							<p>{title}</p>
							<span>
                {
									index === 0
		                ? "The NFD Team is a passionate group committed to simplifying your Web-3 experience. Our mission is to help users succeed in the crypto market, grow personally, and achieve their goals."
		                : index === 1
			                ? "With over three years of experience, we started by developing the NFD Platform. As active market participants, we’ve navigated various projects and token trading, overcoming challenges like managing overwhelming information and staying updated on key developments."
			                : "We’ve launched over five successful, self-funded projects, staying agile and independent from external investors. This allows us to act quickly, delivering tools that empower users to profit from the crypto market without delays."
								}
              </span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default OptimizeActivitiesSection;